<template>
  <div class="signup-member-already-exists-page">
    <div class="emoji">👋</div>
    <div class="title">שמחים שחזרת! מספר הטלפון שלך קיים אצלנו במערכת</div>
    <div class="explain">כנראה שנרשמת כבר לשירות עם המספר הזה.</div>
    <riseup-button title="קחו אותי לתזרים" variant="primary" :action="goToCashflow"/>
    <support-footer />
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import Segment from '@/Segment';
import router from '@/router';

export default {
  name: 'SignupMemberAlreadyExistsError',
  components: {
    SupportFooter: BaseUI.SupportFooter,
    RiseupButton: BaseUI.RiseupButton,
  },
  async created() {
    Segment.trackUserGot('SignupMemberAlreadyExistsError', { phoneNumber: this.phoneNumber });
  },
  props: {
    phoneNumber: {
      type: String,
      required: true,
    },
  },
  methods: {
    goToCashflow() {
      router.push('/sr');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~base-ui/src/scss/riseup-colors';
  @import 'src/scss/mixins';

  .signup-member-already-exists-page {
    @include responsive-padding;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    .emoji {
      margin-top: 50px;
      font-size: 76px;
    }

    .title {
      @include white-page-frame-title;
      margin-top: 30px;
      margin-bottom: 20px;
      line-height: 30px;
    }

    .explain {
      max-width: 300px;
      font-size: 16px;
      line-height: 24px;
      white-space: pre-wrap;

      .explain-bold {
        font-weight: bold;
      }
    }

    .riseup-button {
      margin-top: 30px;
    }

    .support-footer {
      margin-top: 30px;
    }
  }

</style>
